
// components/MailSms/components/MessageAlert.js
import React from 'react';
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';

const MessageAlert = ({ message }) => {
  return (
    <div className={`mb-6 p-4 rounded-lg flex items-center ${
      message.type === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
    }`}>
      {message.type === 'success' ? <FiCheckCircle className="mr-2" /> : <FiXCircle className="mr-2" />}
      {message.text}
    </div>
  );
};

export default MessageAlert;